import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Подушка с рисунком или фото. Область для нанесения - съемный фартучек, закрепляемый на наволочке тесемками к четырем пуговицам. Внутренняя подушка: наполнитель - холофайбер, наволочка - мед. ткань. Съемная наволочка – атласная ткань. Размер подушки 35x35см, размер нанесения 20x20см (нанесение делается на передничек).</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
